import { iFixitHotSpotItem } from './iFixitHotSpotItem';
import { DiagramWiki } from './DiagramWiki';

export const fromWiki = <K extends keyof DiagramWiki>(data: iFixitHotSpotItem, prop: K) => {
   const hasWiki = !!data.wiki;
   // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
   return hasWiki ? data.wiki[prop] : null;
};
